import { Link } from 'react-router-dom'
import { Inbox, ArrowRight } from 'lucide-react'
import { cn } from '@/lib/utils'

/** Hinweis auf die zentrale Freigabe-Fläche (Inbox-Startseite "/"). */
export default function InboxHint({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'flex items-center justify-between gap-3 rounded-md border border-[var(--border)] bg-[var(--muted)] px-3 py-2',
        className,
      )}
    >
      <div className="flex items-center gap-2 text-xs text-[var(--muted-foreground)]">
        <Inbox className="h-4 w-4 shrink-0" />
        <span>Entscheidungen laufen gebündelt über die Freigaben.</span>
      </div>
      <Link
        to="/"
        className="inline-flex shrink-0 items-center gap-1 text-xs font-medium text-[var(--foreground)] hover:underline"
      >
        Zu den Freigaben <ArrowRight className="h-3.5 w-3.5" />
      </Link>
    </div>
  )
}
